// removed by extract-text-webpack-plugin
module.exports = {"betBothButton":"_1TXr65J5npGSUbRegRJHOw","container":"_3YjziQL8L6CCvPtA1REZAJ","arrowRight":"_2XYvi7grztxnBI4_0hmErn","arrowLeft":"_2KV4qk_LQLHBnVHip336eG","wrapper":"_3cxvsoEIflzsKfqSdNBNqb","disabled":"_3wB94gzsAg1S3sl-jhpYwa","disabledArrowLeft":"oh5vBV_Rt1eSAVU8kNn4f","disabledArrowRight":"_36s-CjvKwHPMj6fPEWAZJZ","disabledContainer":"_1ow8i4GN3Br35iiNKJoox-","buttonCustomStyle":"_3HAaudiN14GigQD11d5AGC"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/football/css/betBothCard.css
// module id = 809
// module chunks = 0